import './_pie-chart-overview.scss';
import {Chart} from "chart.js/auto";

export default function PieChartOverview() {
    const $pieChart = document.querySelectorAll('.pie-chart-overview');

    if ($pieChart.length) {
        $pieChart.forEach(($chart) => {
            const dataChart = $chart.querySelector('.data-pie-chart') as HTMLElement;
            const $values = $chart.querySelectorAll('.infos .value');
            let data: any;

            if (dataChart) {
                try {
                    data = JSON.parse(dataChart.innerHTML);
                } catch (e) {
                    data = [];
                }
            }

            function nFormatter($number: any) {
                if ($number >= 1000000000) {
                    return Math.floor(Number($number) / 1000000).toFixed(0) + ' Mld';
                }
                if ($number >= 1000000) {
                    return Math.floor(Number($number) / 1000000).toFixed(0) + ' Mln';
                }
                if ($number >= 1000) {
                    return Math.floor(Number($number) / 1000).toFixed(0) + ' M';
                }
                if ($number <= 1000) {
                    return Math.floor(Number($number)).toFixed(0);
                }
                return $number.toString() + ' ';
            }

            if ($values) {
                $values.forEach(($value: any) => {
                    const $number = $value.querySelector('.number') as any;

                    $number.innerHTML = nFormatter(Number($number.innerHTML));
                })
            }

            let ctx = $chart.querySelector('.chart') as any;

            if (ctx && data && data.length > 0) {
                new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        datasets: [
                            {
                                data: data.map((item: any) => item.value),
                                backgroundColor: ['#003366', 'rgba(0, 51, 102, 0.20)']
                            }
                        ],
                    },
                    options: {
                        cutout: 127,
                        responsive: true,
                        maintainAspectRatio: true,
                        plugins: {
                            tooltip: {
                                enabled: false
                            },
                            legend: {
                                display: false,
                            }
                        }
                    },
                });
            }
        })
    }
}